import type { StaffAccessChange } from '@/apps/apis/mcpAccess/types';

/** The server's own reason when it gives one, so a refusal reads as what the Facade said. */
export const errorMessage = (error: unknown, fallback: string): string => {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  if (typeof message === 'string' && message) {
    return message;
  }
  return error instanceof Error && error.message ? error.message : fallback;
};

const twoDigits = (value: number): string => String(value).padStart(2, '0');

/** "adinda@ · 27 Oct 14:05" in the viewer's time zone, or "—" when no change was recorded. */
export const formatLastChange = (change: StaffAccessChange | null | undefined): string => {
  if (!change) {
    return '—';
  }
  const at = new Date(change.changedAt);
  const month = at.toLocaleString('en-GB', { month: 'short' });
  const actor = change.actorEmail.split('@')[0];
  return `${actor}@ · ${at.getDate()} ${month} ${twoDigits(at.getHours())}:${twoDigits(at.getMinutes())}`;
};

/** The full detail behind the short form, for hover and assistive technology. */
export const lastChangeDetail = (change: StaffAccessChange): string =>
  `Last changed by ${change.actorEmail}, ${new Date(change.changedAt).toLocaleString()}`;

export const formatWhen = (iso: string | null): string => (iso ? new Date(iso).toLocaleString() : 'never');
